import api from '@/api/api';
import { ApiPharmacy } from './';
import { AxiosResponse } from 'axios';
import { IResponseData } from '@/models/common';
import { IPharmacyItem } from '@/models/pharmacy';
import getApiResponse from '@/api/apiResponse';

const PharmacyService = {
  async getPharmacyList() {
    const res: AxiosResponse<IResponseData<Array<IPharmacyItem>>> = await api.get(ApiPharmacy.GET_PHARMACIES);
    return getApiResponse<Array<IPharmacyItem>>(res);
  },
};

export default PharmacyService;
